var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoolDesktop = function SvgPoolDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 819 823"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__a)",
    fillRule: "evenodd",
    d: "M818.749 589.479c0 14.36-101.436 26.698-246.471 32.075-4.919.367-11.279.962-6.784 2.409 9.149 1.946 14.183 4.071 14.183 6.297 0 9.343-88.714 16.918-198.149 16.918-109.434 0-198.148-7.575-198.148-16.918 0-2.47 6.199-4.816 17.342-6.931a56 56 0 0 1 2.841-.667c9.898-2.114.535-2.795-5.137-3.207l-.743-.054C79.193 613.277 0 602.168 0 589.479c0-19.303 183.283-34.951 409.375-34.951 226.091 0 409.374 15.648 409.374 34.951",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__b)",
    fillRule: "evenodd",
    d: "M418.69 640.162c66.125-.467 118.336-6.035 118.336-12.837 0-1.273-1.831-2.504-5.241-3.666 15.143 1.716 24.068 3.825 24.068 6.104 0 5.76-57.007 10.429-127.328 10.429q-4.965 0-9.835-.03",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__c)",
    fillRule: "evenodd",
    d: "M335.086 640.162c-66.126-.467-118.336-6.035-118.336-12.837 0-1.273 1.831-2.504 5.241-3.666-15.143 1.716-24.068 3.825-24.068 6.104 0 5.76 57.006 10.429 127.328 10.429q4.965 0 9.835-.03",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__d)",
    fillRule: "evenodd",
    d: "M421.818 608.199c64.461 0 116.718-7.137 116.718-15.942 0-8.803-52.245-15.94-116.697-15.942m-.021 31.884c-64.462 0-116.718-7.137-116.718-15.942ZM305.1 592.257c0-8.804 52.256-15.942 116.718-15.942Zm116.718-15.942h.001Zm.001 29.107c56.611 0 102.503-6.516 102.503-14.553s-45.881-14.552-102.483-14.554m-.02 29.107c-56.611 0-102.504-6.516-102.504-14.553Zm-102.504-14.553c0-8.038 45.893-14.554 102.504-14.554Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__e)",
    fillRule: "evenodd",
    d: "M421.816 615.805c95.217 0 172.406-10.543 172.406-23.548s-77.189-23.548-172.406-23.548-172.407 10.543-172.407 23.548 77.189 23.548 172.407 23.548m-.001-4.102c83.622 0 151.41-9.625 151.41-21.497s-67.788-21.497-151.409-21.497c-83.622 0-151.411 9.625-151.411 21.497s67.789 21.497 151.41 21.497",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__f)",
    fillRule: "evenodd",
    d: "M246.621 609.928c-56.736-5.201-91.084-11.994-91.084-19.428 0-13.959 121.146-25.663 284.214-28.798-190.534 1.157-340.19 12.713-340.19 26.798 0 8.746 57.701 16.517 147.06 21.428",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__g)",
    fillRule: "evenodd",
    d: "M628.521 599.283c47.668-4.526 76.512-10.431 76.512-16.891 0-6.234-26.866-11.951-71.59-16.412 59.466 4.173 96.423 10.015 96.423 16.483 0 6.643-39.003 12.628-101.345 16.82",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__h)",
    fillRule: "evenodd",
    d: "M724.312 604.018c25.01-4.627 39.106-9.863 39.106-15.408 0-5.963-16.307-11.569-44.961-16.446 47.157 4.508 75.131 10.125 75.131 16.215 0 5.833-25.668 11.233-69.276 15.639",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__i)",
    d: "M182.914 667.71a3 3 0 0 0 6 0zm6 14.65a3 3 0 1 0-6 0zm-6 5.721a3 3 0 1 0 6 0zm0-57.914v37.543h6v-37.543zm0 52.193v5.721h6v-5.721z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__j)",
    d: "M579.674 696.205V630.18l-41.038 9.433v174.588c0 12.469 15.282 10.804 15.282 0v-88.877c20.813.573 25.843-19.174 25.756-29.119"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__k)",
    d: "M445.057 310.786a63.7 63.7 0 0 1-45.022-18.635 63.6 63.6 0 0 1-18.649-44.988c0-26.134 12.097-45.722 26.836-69.587 11.464-18.563 24.526-39.714 34.739-68.545.597-1.685 2.086-6.7 2.086-6.7l.01.032.009-.032s1.49 5.015 2.087 6.7c10.212 28.831 23.274 49.982 34.738 68.545 14.739 23.865 26.836 43.453 26.836 69.587a63.6 63.6 0 0 1-18.648 44.988c-11.857 11.848-28.254 18.635-45.022 18.635"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__l)",
    fillRule: "evenodd",
    d: "M539.636 577.116a135 135 0 0 1-42.783-.12 40.161 40.161 0 0 1-18.705-33.948c0-16.502 7.639-28.87 16.945-43.94l.001-.001c7.239-11.721 15.487-25.077 21.936-43.283.376-1.064 1.317-4.23 1.317-4.23l.006.02.006-.02s.941 3.166 1.318 4.23c6.448 18.206 14.696 31.562 21.935 43.283l.002.003c9.306 15.069 16.944 27.437 16.944 43.938a40.16 40.16 0 0 1-11.776 28.408 40 40 0 0 1-7.146 5.66",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__m)",
    d: "M571.324 81.902a25.03 25.03 0 0 1-17.69-7.322 25 25 0 0 1-7.327-17.675c0-10.268 4.753-17.964 10.544-27.341 4.504-7.294 9.637-15.604 13.649-26.932.234-.662.82-2.632.82-2.632l.004.012.003-.012s.586 1.97.82 2.632c4.013 11.328 9.145 19.638 13.649 26.932 5.791 9.377 10.544 17.073 10.544 27.34a25 25 0 0 1-7.327 17.676c-4.659 4.655-11.101 7.322-17.689 7.322"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__n)",
    d: "M566.923 398.84a16.4 16.4 0 0 1-11.603-4.815 16.45 16.45 0 0 1-4.805-11.622c0-6.751 3.117-11.811 6.915-17.977 2.955-4.795 6.321-10.259 8.952-17.707.154-.436.538-1.731.538-1.731l.003.008.002-.008s.384 1.295.538 1.731c2.632 7.448 5.998 12.912 8.952 17.707 3.798 6.166 6.916 11.226 6.916 17.977a16.45 16.45 0 0 1-4.806 11.622 16.5 16.5 0 0 1-11.602 4.815"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolDesktop_svg__o)",
    d: "M333.004 498.97a16.4 16.4 0 0 1-11.602-4.814 16.45 16.45 0 0 1-4.806-11.622c0-6.751 3.117-11.812 6.916-17.977 2.954-4.795 6.32-10.26 8.952-17.708.154-.435.537-1.731.537-1.731l.003.009.002-.009s.384 1.296.538 1.731c2.632 7.448 5.998 12.913 8.952 17.708 3.798 6.165 6.916 11.226 6.916 17.977a16.45 16.45 0 0 1-4.806 11.622 16.5 16.5 0 0 1-11.602 4.814"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__a",
    x1: 179.32,
    x2: 591.627,
    y1: 614.957,
    y2: 630.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0E2EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__b",
    x1: 418.69,
    x2: 555.853,
    y1: 631.926,
    y2: 631.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__c",
    x1: 466.151,
    x2: 78.557,
    y1: 623.659,
    y2: 613.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFFFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__d",
    x1: 358.891,
    x2: 397.649,
    y1: 639.411,
    y2: 562.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBEE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__e",
    x1: 566.648,
    x2: 290.194,
    y1: 610.32,
    y2: 568.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__f",
    x1: 128.513,
    x2: 299.631,
    y1: 579.839,
    y2: 581.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A594FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__g",
    x1: 628.521,
    x2: 710.121,
    y1: 582.632,
    y2: 592.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADCDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__h",
    x1: 756.022,
    x2: 756.022,
    y1: 572.164,
    y2: 604.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E7D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__i",
    x1: 186.414,
    x2: 186.414,
    y1: 630.386,
    y2: 1004.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__j",
    x1: 559.155,
    x2: 559.155,
    y1: 630.18,
    y2: 844.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7DCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DBFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__k",
    x1: 445.057,
    x2: 445.057,
    y1: -144.919,
    y2: 486.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__l",
    x1: 518.353,
    x2: 518.353,
    y1: -90.438,
    y2: 587.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__m",
    x1: 571.324,
    x2: 571.324,
    y1: -183.588,
    y2: 460.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__n",
    x1: 566.923,
    x2: 566.923,
    y1: 224.276,
    y2: 647.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolDesktop_svg__o",
    x1: 333.004,
    x2: 333.004,
    y1: 324.407,
    y2: 747.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })))));
};
export default SvgPoolDesktop;